import React, { useContext } from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { OwnerType } from '../../../../shared/types/ownerType';
import PageNavigation from '../PageNavigation';
import SharedContext from '../../../../shared/context';
import Badge from '../../../../shared/components/Badge';
import Actions from './Actions';
import CreatorInfo from './CreatorInfo';
import ShareWithTeamBtn from './ShareWithTeamBtn';
import CopyCollectionButton from './CopyCollectionButton';

import './style.scss';

const Header = ({ collection = {} }) => {
    const { userId } = getContext();
    const { businessId } = useContext(SharedContext);

    const { name, description, creator, ownerType, privacyType } = collection;
    const isOwner = userId === creator.id;
    const isPersonal = ownerType === OwnerType.USER;
    const showShareWithTeamBtn = isPersonal && isOwner && !!businessId;
    const showCopyCollectionButton = (isPersonal && !isOwner) || (!isPersonal && !!businessId);
    const displayCtaButton = showShareWithTeamBtn || showCopyCollectionButton;

    return (
        <section className={classNames('header', { 'large-padding-bottom': displayCtaButton })}>
            <div>
                <PageNavigation />
                <Actions />
                <div className="name-cta-container">
                    <div className="title">
                        <h2>{name}</h2>
                        <Badge ownerType={ownerType} privacyType={privacyType} />
                    </div>
                    {showCopyCollectionButton && <CopyCollectionButton isPersonal={isPersonal} />}
                    {showShareWithTeamBtn && <ShareWithTeamBtn />}
                </div>
            </div>
            <div className="info-section">
                <CreatorInfo />
                {description && <p>{description}</p>}
            </div>
        </section>
    );
};

Header.propTypes = {
    collection: object,
};

const mapStateToProps = ({ collection }) => ({ collection });

export { Header };
export default connect(mapStateToProps)(Header);
